/**
 * Add class or classes to an element.
 */
export const addClass = (el: Element, classes = "") => {
  classes.split(" ").forEach((cl) => el.classList.add(cl));
};

/**
 * Add event listener to element.
 */
export const addListener = (events: string, el: Element, handler: any) => {
  events.split(" ").forEach((event) => {
    el.addEventListener(event, handler);
  });
};

/**
 * Find closest element that match with the selector.
 */
export const closest = (el: Element, selector: string) => {
  let parent = el.parentElement || el.parentNode;
  do {
    if (parent && (<Element>parent).matches(selector)) {
      return parent;
    }
    parent = parent && (parent.parentElement || parent.parentNode);
  } while (parent !== null && parent.nodeType === 1);
  return null;
};

/**
 * Create an Element.
 */
export const createEl = (tag = "div", attrs = {}) => {
  const parts = tag.split(".");
  const tagName = parts.shift() || "";
  const el = document.createElement(tagName);
  
  for (let prop in attrs) {
    el.setAttribute(prop, attrs[prop]);
  }
  
  for (let i = 0; i < parts.length; i++) {
    el.classList.add(parts[i]);
  }

  return el;
};

/**
 * Determine if current with is from a mobile.
 */
export const isMobile = (): boolean => window.innerWidth < 767;

/**
 * Search for an element.
 */
export const q = (selector: string, target?: Element) =>
  (target || document).querySelector(selector);

/**
 * Search for elements that matches with selector.
 */
export const qa = (selector: string, target?: Element) =>
  (target || document).querySelectorAll(selector);

/**
 * Remove class or classes from element.
 */
export const removeClass = (el: Element, classes = "") => {
  classes.split(" ").forEach((cl) => el.classList.remove(cl));
};

/**
 * Trigger an event.
 */
export const triggerEvent = (events: string, el: Element) => {
  events.split(" ").forEach((event) => {
    el.dispatchEvent(new Event(event));
  });
};

export const raf =
  window.requestAnimationFrame ||
  window["mozRequestAnimationFrame"] ||
  window["webkitRequestAnimationFrame"] ||
  window["msRequestAnimationFrame"];
